import { useAgreementModal } from '@/hooks/auth/useAgreementModal';
import type { SupplierMordModalState } from '@mondivago/types';

export function useSupplierMordModal(): SupplierMordModalState {
  const result = useAgreementModal({
    documentType: 'supplier_agreement',
    logTable: 'supplier_agreement_logs',
    idField: 'supplier_id',
    profileTable: 'suppliers',
    rpcName: 'insert_supplier_agreement_log',
    seenKey: 'mondivago:supplier-mord-modal-seen',
  });

  return {
    showModal: result.showModal,
    supplierId: result.profileId,
    activeAgreement: result.activeAgreement,
    hasNewVersion: result.hasNewVersion,
    acceptedVersion: result.acceptedVersion,
    loading: result.loading,
    handleClose: result.handleClose,
    openModal: result.openModal,
    refresh: result.refresh,
    acceptAgreement: result.acceptAgreement,
  };
}
